export default "__VITE_ASSET__D8uiKD0j__"